import React, { useState } from "react";
//styling
import forgotPageStyles from "./Forgot.module.scss";
import { ArrowBack } from "@mui/icons-material";
import { CircularProgress, Grid2 } from "@mui/material";
import CustomInput from "../../../../GlobalComponents/CustomInput/CustomInput";
import { useNavigate } from "react-router-dom";
import { resetPassword } from "aws-amplify/auth";
import "react-toastify/dist/ReactToastify.css";
import CustomButton from "../../../../GlobalComponents/CustomButton/CustomButton";
import { verifyEmail, verifyLength } from "../../../../Utils/utils";

export default function NewForgot(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [inputErrorVar, setInputErrorVar] = React.useState({
    email: false,
  });
  const [values, setValues] = React.useState({
    email: "",
    emailState: "error",
    emailErrorMessage: "Email is Required",
  });

  const handleChange = (prop, type, value, length) => {
    let status = "";
    let message = "";
    switch (type) {
      case "email":
        value = value.replace(/\s/g, "");
        if (value === "") {
          status = "error";
          message = "Email is Required";
        } else if (verifyEmail(value)) {
          status = "success";
        } else {
          status = "error";
          message = "Invalid email format";
        }
        break;
      case "length":
        value = value.replace(/\s/g, "");
        if (verifyLength(value, length)) {
          status = "success";
        } else {
          status = "error";
        }
        break;
      default:
        break;
    }
    setInputErrorVar({ ...inputErrorVar, [prop]: false });
    setValues({
      ...values,
      [prop + "State"]: status,
      [prop + "ErrorMessage"]: message,
      [prop]: value,
    });
  };

  const resetPasswordFunc = async () => {
    if (values.emailState === "error") {
      setInputErrorVar({
        ...inputErrorVar,
        email: true,
      });
      return;
    }
    setError(null);
    setLoading(true);
    try {
      const result = await resetPassword({
        username: values.email,
      });
      navigate(`/verify`, {
        state: {
          email: values.email,
          prevPage: "FORGOT",
        },
      });
      setLoading(false);
    } catch (e) {
      const result = await resetPassword({
        username: values.email,
      });
      setError("Failed to send verification email. Please try again.");
      setLoading(false);
    }
  };

  const handleBackClick = () => {
    navigate("/login");
  };

  return (
    <>
      <Grid2 className={forgotPageStyles.ForgotContainer}>
        <Grid2 className={forgotPageStyles.FlexBox}>
          <ArrowBack
            className={forgotPageStyles.cursor}
            onClick={handleBackClick}
          />
          <Grid2 className={forgotPageStyles.back} onClick={handleBackClick}>
            Back
          </Grid2>
        </Grid2>
        <Grid2 className={forgotPageStyles.headerFlexBox}>
          <Grid2 className={forgotPageStyles.Header}>Password Recovery</Grid2>
          <Grid2 className={forgotPageStyles.subHeader}>
            Please enter your registered email address to receive a password
            reset link.
          </Grid2>
        </Grid2>
        <Grid2>
          <CustomInput
            placeholder={"john@company.com"}
            value={values.email}
            setValue={(value) => {
              const cleanedValue = value.replace(/\s/g, "");
              handleChange("email", "email", cleanedValue.toLowerCase());
              setError(null);
            }}
            error={inputErrorVar.email}
            errorMessage={values.emailErrorMessage}
          />
          <Grid2 className={forgotPageStyles.error}>{error}</Grid2>
        </Grid2>
        <CustomButton
          className={forgotPageStyles.ResetPassword}
          onClick={() => resetPasswordFunc()}
        >
          {loading ? (
            <CircularProgress size={25} color={"inherit"} />
          ) : (
            "Send Reset Link"
          )}
        </CustomButton>
      </Grid2>
    </>
  );
}
